import { Box, Collapse } from "@mui/material";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import parse from "html-react-parser";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { selectSelectedLanguage } from "slices/appStateSlice";
import type { LocalDishType } from "types/mainTypes";
import { getDishTypeTextValue } from "utils/utils";

export const CompositionTab = ({ dishType }: { dishType: LocalDishType }) => {
	const selectedLanguage = useAppSelector(selectSelectedLanguage);
	const { t } = useTranslation();
	const [isExpanded, setIsExpanded] = useState(false);

	const handleChange = () => {
		setIsExpanded((prev) => !prev);
	};

	// We have toi temporarily split the composition saved in DB as
	// it also contains the cooking instructions
	const composition = getDishTypeTextValue(dishType, selectedLanguage, "composition");

	return (
		<Box display="flex" justifyContent="space-between" paddingTop={2}>
			<StyledCompositionWrapper>
				{/* TODO: Uncomment when we have real data */}
				{/* <NutritionTable nutritionValues={MOCK_NUTRITION_VALUES} /> */}
				<StyledCollapse in={isExpanded} collapsedSize={90}>
					{parse(composition)}
					<Box />
				</StyledCollapse>
				<Box onClick={() => handleChange()}>
					{isExpanded ? (
						<StyledToggleCollapseButton>{t("common.showLess")}</StyledToggleCollapseButton>
					) : (
						<StyledToggleCollapseButton>{t("common.showMore")}</StyledToggleCollapseButton>
					)}
				</Box>
			</StyledCompositionWrapper>
		</Box>
	);
};

const StyledCollapse = styled(Collapse)(({ theme }) => ({
	"& p, & span": {
		color: `${theme.palette.common.white} !important`, // There might be some styles coming from the DB,
	},
}));
const StyledToggleCollapseButton = styled(
	Typography,
	{},
)(() => ({
	fontWeight: 900,
	marginTop: 8,
	textTransform: "uppercase",
}));

const StyledCompositionWrapper = styled(Box)(() => ({
	"& h5": {
		marginTop: "24px",
	},
	"& table": {
		marginBottom: "32px",
	},
}));
